import React, {useState, useEffect} from 'react'
import '../App.css'
import InputField from './InputField'
import DisplayField from './DisplayField'
import SelectOption from './SelectOption'
import useProfileStore from '../store/profileStore'


function Sidebar() {
  const materialList = ['Standard_55', 'Glossy_55'];
  const colorList = ['Color1', 'Color2', 'Color3'];
  const selectedPts = useProfileStore(state => state.selectedPts)
  const totalLength = useProfileStore(state => state.totalLength)

  const [bends, setBends] = useState(0)

  useEffect(() => {
    setBends(selectedPts.length>2?selectedPts.length-2:0)
  }, [selectedPts])

  return (
    <div className = "sidebar">
      <InputField            
        label='Length (in mm):' 
        id='length'
        isDisabled={false}
      />
      <SelectOption
        label='Material:'
        id='material'
        options={materialList}
      />
      <SelectOption
        label='Colour:'
        id='color'
        options={colorList}
      />
      <DisplayField
        label='No of bends:'
        value={bends}
      />
      <DisplayField
        label='Girth:'
        value={totalLength}
      />
      <DisplayField
        label='Price:'
        value={0}
      />

    </div>
  )
}

export default Sidebar
